import height_expand from "~/components/transitions/heightExpand"

import validationChildMixin from "~/mixins/validationChild"

import { EuclidBase600Black, Sm500Error } from "~/components/typography"

export default {
  mixins: [validationChildMixin],
  components: { EuclidBase600Black, Sm500Error, height_expand },
  data: function () {
    return {
      PRIVATE_VALIDITY: true,
      focus: false,
      copy: "",
    }
  },
  computed: {
    has_picto: function () {
      return this.picto.length > 0
    },
  },
  mounted: function () {
    this.handle_change(this.value)
    this.$set(this, "copy", this.value?.toString() ?? "")
  },
  methods: {
    handle_keyup: function (e) {
      if (e.key === "Enter") this.$emit("enter", e)
      this.$emit("keyup", e)
    },
    handle_blur: function (e) {
      this.$nextTick(() => {
        this.focus = false
      })
      this.$emit("blur", e)
    },
    handle_focus: function (e) {
      this.focus = true
      this.$emit("focus", e)
    },
    handle_change: function (value) {
      this.$emit("input", value)
    },
    handle_update: function (value) {
      this.$set(this, "copy", value.toString())
      this.handle_change(value.toString())
    },
  },
  props: {
    value: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      default: function () {
        return "text"
      },
      validator: function (value) {
        return ["text", "password"].includes(value)
      },
    },
    label: {
      type: [String, Number],
      required: false,
    },
    labelAnnotation: {
      type: [String, Number],
      required: false,
    },
    placeholder: {
      type: String,
      required: false,
      default: function () {
        return ""
      },
    },
    maxlength: {
      type: Number,
      required: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: function () {
        return false
      },
    },
    picto: {
      type: String,
      required: false,
      default: "",
    },
  },
  watch: {
    value: "handle_update",
    copy: "handle_change",
  },
}
